import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Nav,
  NavLink,
  NavMenu,
  HamburgerButton,
  Overlay,
  HomeIcon,
} from "./NavbarElements";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Nav>
        <Link to="/" onClick={closeMenu}>
          <HomeIcon src="/ruetheheads.png" alt="Home" />
        </Link>
        <HamburgerButton isOpen={isOpen} onClick={toggleMenu}>
          <span />
          <span />
          <span />
        </HamburgerButton>
        <Overlay isOpen={isOpen} onClick={closeMenu} />
        <NavMenu isOpen={isOpen}>
          <NavLink to="/" onClick={closeMenu}>
            welcome
          </NavLink>
          <NavLink to="/details" onClick={closeMenu}>
            the details
          </NavLink>
          <NavLink to="/venue" onClick={closeMenu}>
            the venue
          </NavLink>
          <NavLink to="/timeline" onClick={closeMenu}>
            the week
          </NavLink>
          <NavLink to="/formal-rsvp" onClick={closeMenu}>
            rsvp
          </NavLink>
        </NavMenu>
      </Nav>
    </>
  );
};

export default Navbar;
